import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from '@mui/material';

import { SELECTED_ALL_DISPUTES } from './utils';
import { SELECTED_DISPUTES } from '../../../modules/disputes/reducer';

const CheckboxHeader = ({ disputes }) => {
  const dispatch = useDispatch();

  const [isChecked, setIsChecked] = useState(false);

  const user = useSelector(store => store.user);
  const isSuperUser = user.isSuperUser !== null;

  const openDisputes = useMemo(
    () =>
      disputes.flatMap(disputeData => {
        if (!isSuperUser && !disputeData.disputeInfo.openDispute) return [];
        return disputeData;
      }) || [],
    [disputes, isSuperUser]
  );

  const allSelected = useSelector(store => {
    const selectedDisputes = store.disputes.selectedDisputes;
    return selectedDisputes.length ? openDisputes.length === selectedDisputes.length : false;
  });

  useEffect(() => {
    setIsChecked(allSelected);
  }, [allSelected]);

  return (
    <Checkbox
      disabled={!openDisputes.length}
      checked={isChecked}
      onChange={event => {
        const isSelected = event.target.checked;
        setIsChecked(isSelected);
        dispatch({
          type: SELECTED_DISPUTES,
          payload: {
            disputeID: SELECTED_ALL_DISPUTES,
            isSelected,
            isSuperUser
          }
        });
      }}
      size="small"
    />
  );
};

export default CheckboxHeader;
